import { observable, computed, action } from 'mobx';
import { API_URL } from '../constants/constants';
import { CompanyStore } from './CompanyStore';

export class AuthStore {

  public companyStore: CompanyStore;

  @observable
  isAuthenticated: boolean;

  @observable
  role: string;

  constructor(companyStore: CompanyStore) {
    this.isAuthenticated = false;
    this.companyStore = companyStore;
    this.role = '';
  }

  @computed
  get isLoggedIn() {
    return this.isAuthenticated;
  }
  @computed
  get isAdministrator() {
    return this.role === 'administrator' ?  true : false ;
  }

  @action
  async login(email: string, password: string) {
    const url = `${API_URL}/v1/user/login`;
    const payload = { type: 'login', username: email, password: password };
    const headers = new Headers();
    headers.append('Content-type', 'application/json');

    const loginData = await fetch(url, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(payload),
      credentials: 'include'
    })
    .then(data => {
      return data.json();
    })
    .catch(err => {
      return {
        status: 'fail',
        type: 'error',
        message: err.message + ': Virhe sisäänkirjautumisessa',
        seen: false
      };
    });

    if (loginData.token && loginData.user) {
      this.isAuthenticated = true;
      localStorage.setItem('userId', loginData.user.uid);
      localStorage.setItem('token', loginData.token);
    } else {
      return {
        status: 'fail',
        message: 'Virhe sisäänkirjautumisessa'
      };
    }
    return loginData;
  }

  async clearDrupalCache() {
    const token = localStorage.getItem('token');
    const company = this.companyStore.selectedCompany;
    const url = `${API_URL}/v1/clear-cache?company=${company}`;
    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    const clearCacheData = await fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include'
    })
    .then(data => {
      return data.json();
    });
  }

  @action
  async logout() {
    const token = localStorage.getItem('token');
    const url = `${API_URL}/v1/user/logout`;
    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    const logoutData = await fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include'
    })
    .then(data => {
      return data.json();
    })
    .catch(err => {
      return {
        status: 'fail',
        type: 'error',
        message: err.message + ': Virhe sisäänkirjautumisessa',
        seen: false
      };
    });

    this.isAuthenticated = false;
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userNavId');
    window.location.replace(`${API_URL}/user/logout`);
  }

  @action
  async testIsLoggedIn() {
    const token = localStorage.getItem('token');
    const url = `${API_URL}/services/session/token`;
    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    const loginData = await fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include'
    })
    .then(data => {
      return data.text();
    })
    .catch(err => {
      return {
        status: 'fail',
        type: 'error',
        message: err.message + ': Virhe sisäänkirjautumisessa',
        seen: false
      };
    });

    if (loginData &&
        loginData === localStorage.getItem('token')) {
      this.isAuthenticated = true;
      return { status: 'success' };
    } else {
      return { status: 'fail' };
    }
  }
  @action
  async getUserRole() {
    const userData = await this.getUser()
      .then(response => {
        return response.json();
      })
      .catch(e => {
        return { status: 'error', message: e };
      });
    for (const role in userData.roles) {
      if (userData.roles[role] === 'administrator') {
        this.role = userData.roles[role];
      }
    }
  }

  @action
  getUser() {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    const url = `${API_URL}/v1/user/${userId}`;
    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    return fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include'
    });
  }
}

export default AuthStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/AuthStore.ts